import { render, staticRenderFns } from "./VideoDetails.vue?vue&type=template&id=2728e28e&"
import script from "./VideoDetails.vue?vue&type=script&lang=js&"
export * from "./VideoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports